import { useCallback, useRef } from 'react';

/**
 * 결재라인(회사지정 템플릿)을 고를 때의 참조자 목록.
 * 직접 고른 참조자는 유지하고, 이전에 고른 결재라인에서 들어온 참조자만 새 결재라인의 참조자로 바꾼다.
 * @param {Array} currentCcUsers   현재 폼의 참조자
 * @param {Array} prevLineCcUsers  직전에 고른 결재라인에서 들어온 참조자(처음이면 [])
 * @param {Array} nextLineCcUsers  새로 고른 결재라인의 참조자
 * @returns {{ ccUsers: Array, lineCcUsers: Array }} 폼에 넣을 참조자, 다음 호출에 넘길 결재라인 참조자
 */
export const mergeLineCcUsers = (currentCcUsers, prevLineCcUsers, nextLineCcUsers) => {
	const prevLineIds = new Set((prevLineCcUsers || []).map((c) => c?.userId));
	const kept = (currentCcUsers || []).filter((c) => !prevLineIds.has(c?.userId));
	const added = (nextLineCcUsers || []).filter((c) => !kept.some((k) => k?.userId === c?.userId));
	return { ccUsers: [...kept, ...added], lineCcUsers: added };
};

/**
 * mergeLineCcUsers를 컴포넌트에서 쓰는 훅. 직전에 고른 결재라인의 참조자를 내부 ref로 기억한다.
 * 예) const mergeLineCc = useLineCcMerge();
 *     form.setFieldValue('ccUsers', mergeLineCc(form.values.ccUsers, approval?.ccUsers));
 */
export const useLineCcMerge = () => {
	const lineCcUsersRef = useRef([]);
	return useCallback((currentCcUsers, nextLineCcUsers) => {
		const { ccUsers, lineCcUsers } = mergeLineCcUsers(currentCcUsers, lineCcUsersRef.current, nextLineCcUsers);
		lineCcUsersRef.current = lineCcUsers;
		return ccUsers;
	}, []);
};
